var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var env_check = process.env.NEXT_PUBLIC_ENV === 'STAGING' || process.env.NEXT_PUBLIC_ENV === 'PROD';
export var CATEGORIES = {
    search: 'search',
    saved: 'saved',
    auth: 'auth',
    deposit: 'deposit',
    home: 'home',
    portfolio: 'portfolio',
    withdraw: 'withdraw',
    trade: 'trade',
    asset: 'asset',
    navigation: 'navigation',
};
export var EVENTS = {
    search: {
        searchToken: 'Search Token',
        clickToken: 'Click Token',
        viewTopTokens: 'View Top Tokens',
        viewHotTokens: 'View Hot Tokens',
        viewRecentTokens: 'View Recent Tokens',
        viewCashTokens: 'View Cash Tokens',
        viewMemeTokens: 'View Meme Tokens',
        viewNativeTokens: 'View Native Tokens',
        clickTopToken: 'Click Top Token',
        clickStableToken: 'Click Stable Token',
        clickNativeToken: 'Click Native  Token',
    },
    auth: {
        signup: 'Signup',
        login: 'Login',
        signout: 'Signout',
    },
    deposit: {
        startDeposit: 'Start Deposit',
        finalizeDeposit: 'Finalize Deposit',
    },
    home: {
        goToDeposit: 'Go To Deposit',
        goToTrade: 'Go To Trade',
        viewPortfolio: 'View Assets',
    },
    portfolio: {
        startTrade: 'Start Trade',
        goToWithdraw: 'Go to Withdraw',
        clickToken: 'Click Token',
        viewReceipt: 'View Receipt',
    },
    withdraw: {
        startWithdraw: 'Start Withdraw',
        finalizeWithdraw: 'Finalize Withdraw',
    },
    trade: {
        startTrade: 'Start Single Chain Trade',
        finalizeTrade: 'Finalize Single Chain Trade',
    },
    asset: {
        goToTrade: 'goToTrade',
        saveToken: 'Save Token',
    },
    navigation: {
        goToTrade: 'Go To Trade',
        goToExplore: 'Go To Explore',
        goToSaved: 'Go To Saved',
        goToSettings: 'Go To Settings',
        goToPoints: 'Go To Points',
    },
};
var sendToMixpanel = function (eventName, eventProperties) { return __awaiter(void 0, void 0, void 0, function () {
    var locationResponse, locationData, urlParams, utmParams, additionalProperties, properties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!env_check) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, fetch('/api/proxy')];
            case 1:
                locationResponse = _a.sent();
                return [4 /*yield*/, locationResponse.json()];
            case 2:
                locationData = _a.sent();
                urlParams = new URLSearchParams(window.location.search);
                utmParams = {
                    utm_source: urlParams.get('utm_source') || undefined,
                    utm_medium: urlParams.get('utm_medium') || undefined,
                    utm_campaign: urlParams.get('utm_campaign') || undefined,
                    utm_term: urlParams.get('utm_term') || undefined,
                    utm_content: urlParams.get('utm_content') || undefined,
                    id: urlParams.get('id') || undefined,
                };
                additionalProperties = __assign({ $browser: navigator.userAgent, $browser_version: navigator.appVersion, $city: locationData.city, $region: locationData.region_name, mp_country_code: locationData.country_name, $current_url: window.location.href, $device: navigator.platform, $device_id: navigator.userAgent, $initial_referrer: document.referrer ? document.referrer : undefined, $initial_referring_domain: document.referrer ? new URL(document.referrer).hostname : undefined, $os: navigator.platform, $screen_height: window.screen.height, $screen_width: window.screen.width }, utmParams);
                properties = __assign(__assign({}, eventProperties), additionalProperties);
                fetch('/api/mixpanel', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        event: eventName,
                        properties: properties,
                    }),
                });
                return [2 /*return*/];
        }
    });
}); };
export var LogToMixpanel = function (_a) {
    var pkp = _a.pkp, eventName = _a.eventName, category = _a.category, metaData = _a.metaData;
    if (!env_check) {
        return;
    }
    metaData = metaData
        ? Object.keys(metaData).reduce(function (acc, key) {
            if (metaData[key] !== undefined) {
                acc[key] = metaData[key];
            }
            return acc;
        }, {})
        : {};
    sendToMixpanel(eventName, __assign(__assign({ category: category }, metaData), { $name: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress, $email: pkp === null || pkp === void 0 ? void 0 : pkp.email, email: pkp === null || pkp === void 0 ? void 0 : pkp.email, username: pkp === null || pkp === void 0 ? void 0 : pkp.username, first_name: (pkp === null || pkp === void 0 ? void 0 : pkp.firstName) || (pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress), last_name: (pkp === null || pkp === void 0 ? void 0 : pkp.lastName) || (pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress), distinct_id: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress, vaultEthAddress: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress, additionalEthAddress: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress, solanaAddress: pkp === null || pkp === void 0 ? void 0 : pkp.solanaAddress, $user_id: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress }));
};
export var useMixpanel = function () {
    return {
        EVENTS: EVENTS,
        CATEGORIES: CATEGORIES,
        LogToMixpanel: LogToMixpanel,
    };
};
